export default "__VITE_ASSET__CF5Lpt02__"